import axios from "axios";
import jwt_decode from "jwt-decode";
import { logOut } from "../../common/utils";

export default class LoginService{
   
   login(utente, password, cf, onSuccess, onError){
        sessionStorage.clear();
      let host = process.env.REACT_APP_API_URL;
      const headers = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin' : '*',
      'Access-Control-Allow-Headers' : 'Origin, X-Requested-With, Content-Type, Accept',
      'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
   };
   axios.post(host+"/public/auth/login",
                                 {
                                    utente:utente, 
                                    password:password, 
                                    codiceFiscale:cf
                                },
                                {
                                    headers: headers
                                }
   ).then(function(result){
         var decoded = jwt_decode(result.data.token);
         if(decoded.RUOLO === 0 || decoded.RUOLO ==="0"){
          onError(decoded.RUOLO)
         }else{
            var result = "{\"username\":\""+utente+"\",\"token\":\""+result.data.token+"\"}";
            sessionStorage.setItem('user', result);
            onSuccess(result);
        }
        
   }, function(error){
         console.error("Errore durante il login: ", error);
         onError(error);
   });
} 


getImpostazioni(onSuccess){
   let host = process.env.REACT_APP_API_URL;
   var objUser = JSON.parse(sessionStorage.getItem("user"));
   var decoded = jwt_decode(objUser.token);
   const configHeaders = {
     headers: {
       Authorization: "Bearer " + objUser.token,
       CF: decoded.CFA,
       "Content-Type": "application/json",
       "Access-Control-Allow-Origin": "*",
       "Access-Control-Allow-Headers":
         "Origin, X-Requested-With, Content-Type, Accept",
       "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
     },
   };
   axios
     .get(host + "/api/v1/impostazioni/findAll", configHeaders)
     .then(
       function (result) {
        if(result.status === 401){
          logOut();
        }
         result.data.map((val) => {
          
            //  if(val.key === "help_desk"){
            //    sessionStorage.removeItem("key-Segnalazioni");
            //    sessionStorage.setItem('key-Segnalazioni', JSON.stringify(val));
            // }
            sessionStorage.removeItem(val.key);
            sessionStorage.setItem("Imp_" +val.key, JSON.stringify(val.value));
            return <></>
         })
        //  console.log(result.data);
         onSuccess(result.data);
       },
       function (error) {
        if(error.response.status === 401){
          logOut();
        }
         console.log(
           "errore " + error
         );
         onSuccess([]);
       }
     );
 }


}